import { css } from 'styled-components';
const FocusStyle = css(["&:focus-within{outline:none;border-radius:var(--border-radius-rounded);box-shadow:0px 0px 0px 4px var(--neutral-border);}"]);
export default FocusStyle;